import UICardGrid from 'UIComponents/card/UICardGrid';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { useTrackSolutionsDirectoryClickResultItem } from 'marketplace-ui-tracking';
import { useMemo } from 'react';
// @ts-expect-error untyped import
import ResultCard from './ResultCard';
import { jsx as _jsx } from "react/jsx-runtime";
export function ResultsGrid({
  onResultClick,
  results
}) {
  const {
    trackClickResultItem
  } = useTrackSolutionsDirectoryClickResultItem();
  const renderedResults = useMemo(() => {
    return results.toArray().map((result, index) => {
      return /*#__PURE__*/_jsx(ResultCard, {
        onClick: () => {
          if (onResultClick) {
            onResultClick(result, index);
          }
          trackClickResultItem(result, {
            itemIndex: index,
            totalResults: results.size
          });
        },
        result: result
      }, result.name);
    });
  }, [onResultClick, results, trackClickResultItem]);
  const responsiveProps = useResponsiveProps({
    columns: {
      xs: 1,
      sm: 2,
      lg: 3
    }
  });
  return /*#__PURE__*/_jsx(UICardGrid, Object.assign({
    "data-test-id": "search-results-grid",
    gutterSize: 16
  }, responsiveProps, {
    children: renderedResults
  }));
}